import React from "react";
import { Button } from "react-bootstrap";
import "./Button.css";
import styled from "styled-components";
const ButtonStyle = styled.button`
  background: linear-gradient(135deg, #FFD700 0%, #F59E0B 100%);
  font-size: 16px;
  color: #0B132B;
  font-family: "bold", sans-serif;
  font-weight: 800;
  padding: 10px 24px;
  border: 0 !important;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
  cursor: pointer;
  transition: all 0.25s ease;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(245, 158, 11, 0.6);
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    box-shadow: none !important;
  }
`;
const CloseStyle = styled.button`
  font-size: 15px;
  border: 0 !important;
  color: #000;
  background: none;
`;
const Buttons = ({ label, onClick, fullWidth, disabled, className, style }) => {
  return (
    <>
      <ButtonStyle
        onClick={onClick}
        fullWidth={fullWidth}
        disabled={disabled}
        className={className}
        style={style}
      >
        {label}
      </ButtonStyle>
    </>
  );
};
const Close = ({ label, onClick }) => {
  return (
    <>
      <CloseStyle onClick={onClick}>{label}</CloseStyle>
    </>
  );
};

const ButtonView = ({ label, onClick, className }) => {
  return (
    <div>
      <Button onClick={onClick} className={className}>
        {label}
      </Button>
    </div>
  );
};

export { Buttons, Close, ButtonView };
